import { ReactNode } from 'react';
import { IconArrowRightRegular, IconInfoRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export interface ShippingNoticeBannerProps {
  show_arrow_icon?: boolean;
  onClick: () => void;
  children: ReactNode;
}

export const ShippingNoticeBanner: React.FC<React.PropsWithChildren<ShippingNoticeBannerProps>> = ({ show_arrow_icon, onClick, children }) => {
  return (
    <Wrapper type='button' onClick={onClick}>
      <div className='banner'>
        <span className={`content ${Typography.BODY_14_MEDIUM}`}>
          <IconInfoRegular v3Color='gray600' width={20} height={20} />
          <span className='content-text'>{children}</span>
          {show_arrow_icon && <IconArrowRightRegular v3Color='gray400' width={20} />}
        </span>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.button`
  padding: 0 16px 16px;
  width: 100%;
  cursor: pointer;

  .banner {
    background: ${vars.v3Color.gray100};
    border-radius: 8px;
    padding: 0 12px;
    width: 100%;

    .content {
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${vars.v3Color.gray600};

      .content-text {
        flex: 1;
        text-align: left;
        margin: 0 0 0 2px;
        padding: 0 39px 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; /* 말줄임 적용 */
      }
    }
  }
`;
